export { Modal } from "./modal"
export type { IModalProps } from "./modal"
